import type React from 'react';
import {
  VStack,
  Heading,
  Text,
  Accordion,
  AccordionItem,
  AccordionButton,
  Box,
  AccordionPanel,
  Flex,
} from '@chakra-ui/react';
import { AiOutlineUpCircle, AiOutlineDownCircle } from 'react-icons/ai';
import { UPDATED_GENERAL_FAQ } from '@/constants/tournamentRulesCopy';
import { useHomePageColors } from '@/hooks/useHomePageColors';
import './home.css';

const FAQSection: React.FC = () => {
  const { heading, surfaceMuted, brandAccent, bodyMuted } = useHomePageColors();

  const faqData = UPDATED_GENERAL_FAQ;

  return (
    <VStack
      pb='24px'
      px={{
        base: '1em',
        md: '24px',
      }}
    >
      <Heading
        mb='1em'
        fontStyle='italic'
        textAlign='center'
        color={heading}
        fontWeight={700}
        w={{
          base: '60%',
          md: '100%',
        }}
        fontSize={{
          base: '16px',
          md: '19px',
          lg: '26px',
          xl: '32px',
        }}
      >
        Frequently Asked Questions
      </Heading>
      <Accordion maxW='full' w='full' allowToggle>
        <Flex flexDir='column' w='100%' gap='14px'>
          {faqData.map(({ question, answer }, index) => (
            <AccordionItem key={index} border='none'>
              {({ isExpanded }) => (
                <>
                  <AccordionButton
                    border='none'
                    py='1.0em'
                    bgColor={surfaceMuted}
                    borderTopRadius='8px'
                    borderBottomRadius={isExpanded && answer ? 0 : '8px'}
                    overflowX='hidden'
                    _hover={{ bg: surfaceMuted }}
                  >
                    <Box as='span' flex='1' textAlign='left'>
                      <Text
                        as='b'
                        fontWeight={600}
                        fontSize={{
                          base: '13px',
                          md: '15px',
                        }}
                      >
                        {question}
                      </Text>
                    </Box>
                    {isExpanded ? (
                      <AiOutlineUpCircle size='24px' fill={brandAccent} />
                    ) : (
                      <AiOutlineDownCircle size='24px' fill={brandAccent} />
                    )}
                  </AccordionButton>
                  {answer && (
                    <AccordionPanel
                      pb={4}
                      bgColor={surfaceMuted}
                      borderBottomRadius='8px'
                      color={bodyMuted}
                      textAlign='left'
                      fontSize={{
                        base: '13px',
                        md: '14px',
                      }}
                    >
                      {answer}
                    </AccordionPanel>
                  )}
                </>
              )}
            </AccordionItem>
          ))}
        </Flex>
      </Accordion>
    </VStack>
  );
};

export default FAQSection;
